export enum SupportedFile {
  CSV = 'CSV',
  JSON = 'JSON',
  PDF = 'PDF',
  DMN = 'DMN',
}
